import React, { Component } from "react";
import { Div, Text, Image } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";
export default class SalesQuestion extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div m={{ t: "6.6rem" }} className="solutions">
            <Div textAlign={{ xs: "left", md: "center" }} className="solutions">
              <Text
                className="white-text-gradient"
                style={{ letterSpacing: "2px" }}
                textSize="caption2"
                textWeight="bold"
                m={{ b: "1rem" }}
              >
                {content.gradient}
              </Text>
              <Text textSize="title2" tag="h2" textWeight="bold" m={{ b: ".8rem" }}>
                {content.heading}
              </Text>
              <Text
                className="sub-text"
                maxW="51.25rem"
                textSize={{ xs: "15px", md: "paragraph" }}
                textColor="#D9D9D9"
                m="0 auto 2.94rem"
              >
                {content.text}
              </Text>
            </Div>
            <Div
              d={{ xs: "block", md: "flex" }}
              justify="space-between"
              m={{ t: { xs: "5.75rem", md: "0" } }}
            >
              {content.questionCards.map((data, index) => {
                const even = index % 2 == 0;
                return (
                  <Div
                    key={index}
                    maxW={{ xs: "100%", md: "16.9rem" }}
                    m={{ b: {xs: "6.25rem", md: "0"} }}
                  >
                    <Div>
                      <ImageLink link={data.imgLink}><Div
                        bgImg={data.img}
                        p={{ b: "100%" }}
                        bgSize="cover"
                        bgRepeat="no-repeat"
                        bgPos="center"
                      ></Div></ImageLink>
                    </Div>
                    <Div m={{ t: { xs: "2rem", md: "3rem" } }}>
                      <Text
                        m={{ b: ".5rem" }}
                        textWeight="bold"
                        textColor="gray700"
                        fontFamily="secondary"
                      >
                        {data.count}
                      </Text>
                      <Text
                        m={{ b: { xs: ".8rem", md: ".5rem" } }}
                        className="main-text"
                        textSize={{ xs: "caption4", md: "subheader6" }}
                        textWeight="bold"
                        maxW={{xs: "100%", md: "14.125rem"}}
                        tag="h3"
                      >
                        {data.heading}
                      </Text>
                      <Text textColor="#d9d9d9">{data.info1}</Text>
                      <Text textColor="#d9d9d9" m={{ t: "1.6rem" }}>
                        {data.info2}
                      </Text>
                    </Div>
                  </Div>
                );
              })}
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
